import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators'
import { Route } from 'vue-router'
import store from '@/store'
interface IHistory {
    path: string
    routeName: string
}
export interface ITagView {
    title?: string, // 标题
    module: number, //属于哪个模块
    key: string, // 标识，使用菜单的url
    path: string, // 当前指向的路径
    routeName: string, //当前路由的名称
    meta?: any,
    query?: string,
    active: boolean,
    history: Array<IHistory>
}

export interface ITagsViewState {
    visitedViews: ITagView[]
    cachedViews: (string | undefined)[]
}

@Module({ dynamic: true, store, name: 'tagsView' })
class TagsView extends VuexModule implements ITagsViewState {
    public visitedViews: ITagView[] = []
    public cachedViews: (string | undefined)[] = []

    @Mutation
    private ADD_VISITED_VIEW(view: ITagView) {
        this.visitedViews.forEach(w => w.active = false);
        const v = this.visitedViews.find(s => s.key === view.key);
        if(v){
            v.active = true;
        } else {
            this.visitedViews.push(
                Object.assign({}, view, {
                    title: view.title
                })
            )
        }
    }

    @Mutation
    private ADD_CACHED_VIEW(view: ITagView) {
        if (this.cachedViews.includes(view.routeName)) return
        if (!view.meta || !view.meta.noCache) {
            this.cachedViews.push(view.routeName)
        }
    }

    @Mutation
    private DEL_VISITED_VIEW(view: ITagView) {
        for (const [i, v] of this.visitedViews.entries()) {
            if (v.key === view.key) {
                this.visitedViews.splice(i, 1)
                break
            }
        }
    }

    @Mutation
    private DEL_CACHED_VIEW(view: ITagView) {
        const index = this.cachedViews.indexOf(view.routeName)
        index > -1 && this.cachedViews.splice(index, 1)
    }

    @Mutation
    private DEL_OTHERS_VISITED_VIEWS(view: ITagView) {
        this.visitedViews = this.visitedViews.filter(v => {
            return v.meta && v.meta.affix || v.key === view.key
        })
    }

    @Mutation
    private DEL_OTHERS_CACHED_VIEWS(view: ITagView) {
        const index = this.cachedViews.indexOf(view.routeName)
        if (index > -1) {
            this.cachedViews = this.cachedViews.slice(index, index + 1)
        } else {
            // if index = -1, there is no cached tags
            this.cachedViews = []
        }
    }

    @Mutation
    private DEL_ALL_VISITED_VIEWS() {
        // keep affix tags
        const affixTags = this.visitedViews.filter(tag => tag.meta && tag.meta.affix)
        this.visitedViews = affixTags
    }
    @Mutation
    private CLEAR_VIEWS() {
        // keep affix tags
        this.visitedViews = []
        this.cachedViews = []
    }

    @Mutation
    private DEL_ALL_CACHED_VIEWS() {
        this.cachedViews = []
    }

    @Mutation
    private UPDATE_VISITED_VIEW(view: ITagView) {
        for (let v of this.visitedViews) {
            if (v.key === view.key) {
                v = Object.assign(v, view)
                break
            }
        }
    }

    @Action
    public addView(view: ITagView) {
        this.ADD_VISITED_VIEW(view)
        this.ADD_CACHED_VIEW(view)
    }

    @Action
    public addVisitedView(view: ITagView) {
        this.ADD_VISITED_VIEW(view)
    }

    @Action
    public delView(view: ITagView) {
        this.DEL_VISITED_VIEW(view)
        this.DEL_CACHED_VIEW(view)
    }

    @Action
    public delCachedView(view: ITagView) {
        this.DEL_CACHED_VIEW(view)
    }

    @Action
    public delOthersViews(view: ITagView) {
        this.DEL_OTHERS_VISITED_VIEWS(view)
        this.DEL_OTHERS_CACHED_VIEWS(view)
    }

    @Action
    public delAllViews() {
        this.DEL_ALL_VISITED_VIEWS()
        this.DEL_ALL_CACHED_VIEWS()
    }
    @Action
    public clearViews() {
        this.CLEAR_VIEWS()
    }

    @Action
    public delAllCachedViews() {
        this.DEL_ALL_CACHED_VIEWS()
    }

    @Action
    public updateVisitedView(view: ITagView) {
        this.UPDATE_VISITED_VIEW(view)
    }
}

export const TagsViewModule = getModule(TagsView)
